export default "__VITE_ASSET__CpQg45t3__"